import type { DraftResult } from './idle';

// Ce que l'editeur dit au suivi d'activite (CNX) : un rendu ou une video en cours, le projet ouvert et son travail
// non enregistre. Un petit magasin a abonnement, lu par useSyncExternalStore : le suivi d'activite vit au-dessus
// de l'editeur, dans SessionProvider.

export type EditorHandle = {
  projectName: string;
  /** Du travail non enregistre, dans cet onglet ou un autre onglet du projet */
  unsaved: boolean;
  /** Enregistrer le projet (« Enregistrer et rester ») */
  save: () => Promise<void>;
  /** Garder le travail non enregistre avant la deconnexion pour inactivite */
  keepDraft: () => Promise<DraftResult>;
  /** Quitter la page sans la question du navigateur (deconnexion automatique, fermeture sans enregistrer) */
  allowLeave: () => void;
};

type Listener = () => void;
const listeners = new Set<Listener>();
let backgroundJob = false;
let editor: EditorHandle | null = null;
const notify = () => listeners.forEach((l) => l());

export const idleStore = {
  setBackgroundJob(value: boolean) {
    if (value === backgroundJob) return;
    backgroundJob = value;
    notify();
  },
  getBackgroundJob: () => backgroundJob,
  setEditor(handle: EditorHandle | null) {
    editor = handle;
    notify();
  },
  getEditor: () => editor,
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
